import { Construction } from 'lucide-react'

interface PhaseStubProps {
  title: string
  phase: number
  summary: string
  /** What this screen needs before it can be built. */
  blockedBy?: string
}

/**
 * Placeholder for a screen a later phase owns.
 *
 * It names the phase and the dependency rather than saying "coming soon",
 * because the useful question when you land here is "what has to happen
 * first" — and that answer is in ROADMAP.md, so this points at it.
 */
export function PhaseStub({ title, phase, summary, blockedBy }: PhaseStubProps) {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="qbar-panel max-w-md p-8 text-center">
        <Construction size={22} className="mx-auto mb-3 text-warning" />
        <h1 className="font-display text-lg font-bold text-foreground">{title}</h1>
        <p className="qbar-badge mx-auto mt-2 border-warning/40 text-warning">PHASE {phase}</p>
        <p className="mt-3 text-[12px] leading-relaxed text-muted-foreground">{summary}</p>
        {blockedBy && (
          <p className="mt-3 border-t border-border pt-3 text-[11px] text-muted-foreground/80">
            Needs first: {blockedBy}
          </p>
        )}
        <p className="mt-3 text-[10px] text-muted-foreground/60">See ROADMAP.md</p>
      </div>
    </div>
  )
}
